import React, { useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import theme from './theme';
import Login from './components/Login';
import Chat from './components/Chat';
import './i18n';

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isRtl, setIsRtl] = useState<boolean>(true); // افتراضياً العربية (RTL)

  useEffect(() => {
    // التحقق من حالة تسجيل الدخول المحفوظة
    const loginStatus = localStorage.getItem('isLoggedIn');
    if (loginStatus === 'true') {
      setIsLoggedIn(true);
    }
    
    // تعيين اتجاه المستند بناءً على اللغة
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }, [isRtl]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
  };

  const handleLanguageChange = (isArabic: boolean) => {
    setIsRtl(isArabic);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ 
        bgcolor: 'background.default', 
        minHeight: '100vh',
        direction: isRtl ? 'rtl' : 'ltr'
      }}>
        <Router>
          <Routes>
            <Route 
              path="/" 
              element={
                isLoggedIn ? 
                <Chat onLogout={handleLogout} /> : 
                <Login onLogin={handleLogin} />
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </Box>
    </ThemeProvider>
  );
};

export default App;
